// extracted by mini-css-extract-plugin
module.exports = {"Component":"SectionWrapper_Component__3GaU3"};